import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";

export const BlackFridayPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  // Popup disabled - no auto-open
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setIsOpen(true);
  //   }, 1000);
  //   return () => clearTimeout(timer);
  // }, []);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="max-w-2xl border-0 bg-[#1a1a1a] text-white p-0 overflow-hidden">
        <div className="relative px-4 md:px-8 py-8">
          <DialogHeader className="space-y-4 text-center items-center">
            {/* BLACK FRIDAY Title */}
            <DialogTitle className="text-3xl md:text-5xl lg:text-6xl font-display tracking-[0.05em] md:tracking-[0.08em] text-white whitespace-nowrap">
              BLACK FRIDAY
            </DialogTitle>

            {/* MÉGA PROMO Badge */}
            <div className="flex justify-center">
              <div className="inline-flex items-center gap-2 md:gap-3 px-3 md:px-6 py-1.5 md:py-2.5 bg-gradient-to-r from-orange-400 to-orange-500 text-white font-bold text-xs md:text-lg lg:text-xl uppercase tracking-[0.05em] md:tracking-[0.1em] shadow-lg">
                <Sparkles className="h-3 w-3 md:h-4 md:w-4" />
                &nbsp;MÉGA PROMO
                <Sparkles className="h-3 w-3 md:h-4 md:w-4" />
              </div>
            </div>

            {/* -40% */}
            <div className="text-5xl md:text-7xl lg:text-8xl font-black py-2 bg-gradient-to-r from-[#FFD700] via-[#FFA500] to-[#FF8C00] bg-clip-text text-transparent drop-shadow-[0_0_30px_rgba(255,215,0,0.5)]">
              -40%
            </div>

            {/* Subtitle */}
            <DialogDescription className="text-xl md:text-2xl lg:text-3xl text-white font-medium text-center">
              Sur tous nos albums photo !
            </DialogDescription>

            {/* Description */}
            <div className="space-y-3 pt-1 flex flex-col items-center">
              <p className="text-white text-center text-sm md:text-base px-2">
                Profitez de notre offre exceptionnelle Black Friday
                <br />
                Créez vos albums photo à prix réduit
              </p>

              {/* CTA Button */}
              <div className="flex justify-center pt-4 w-full">
                <Button
                  size="lg"
                  className="bg-gradient-to-r from-orange-400 to-orange-500 hover:from-orange-500 hover:to-orange-600 text-white font-bold text-base md:text-xl px-8 md:px-12 py-6 md:py-7 rounded-full shadow-2xl shadow-orange-500/50 transition-transform hover:scale-105"
                  onClick={() => {
                    setIsOpen(false);
                    document.getElementById("albums")?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  J'en profite ! 🔥
                </Button>
              </div>

              {/* Footer with clock emojis */}
              <p className="text-xs md:text-sm text-white pt-4 text-center px-2">
                ⏰ Offre valable jusqu'au 1 décembre 2025 ⏰
              </p>
            </div>
          </DialogHeader>
        </div>
      </DialogContent>
    </Dialog>
  );
};
